import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsTipDisposition extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public title: string;

  @Expose()
  public organization: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
